// extracted by mini-css-extract-plugin
export default {"input":"SbatGroupSuperBatchProject_input__rL0-D"};